// Toppers UtilityPage content-title bar, rendered in-tree.
//
// This layout ALWAYS uses the pre_order phone: it renders "Talk to Sleep
// Expert" + the pre_order phone `<a>` unconditionally when
// CustomerServiceSettings exists, and does NOT consult the page's
// `show_phone_number` field (that field is vestigial here). The phone
// href/display are RESOLVED SERVER-SIDE (`as_rfc3966` / `as_national`).
import React from "react";
import { t } from "ttag";

type IProps = {
    title: string;
    phoneHref: string;
    phoneDisplay: string;
};

export const ContentTitle = (props: IProps): React.JSX.Element => {
    const { title, phoneHref, phoneDisplay } = props;
    return (
        <div className="content-title">
            <h1 className="content-title__headline">{title}</h1>
            <span className="content-title__info">
                {t`Talk to Sleep Expert`}
                {phoneHref ? <a href={phoneHref}>{phoneDisplay}</a> : null}
            </span>
        </div>
    );
};
